import { Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import classnames from 'classnames';
import styles from '../scoutingForm.css';

export type ScoutingFormIsEditingTitle = {
  title: string;
  subtitle?: string;
  leftLabel?: string;
  rightLabel?: string;
  customRightIcon?: string;
  onLeft: () => void;
  onRight?: () => void;
}

export const ScoutingFormIsEditingTitle = ({ title, subtitle, leftLabel, rightLabel, customRightIcon, onLeft, onRight }: ScoutingFormIsEditingTitle) => (
  <div className={classnames(styles.enhancedScoutingHeader, styles.enhancedScoutingHeaderEditingTitle)}>
    <div className={styles.enhancedScoutingIsSelecting}>
      <div className={`${styles.enhancedScoutingIsSelectingLeftContainer} ${styles.cursorPointer}`} onClick={onLeft}>
        <Icon
          glyph={Icon.set.ARROW_LEFT}
          testId="enhanced-scouting-arrow-left"
          className={styles.enhancedScoutingIsSelectingDoneIconContainer}
        />
        {leftLabel ?? getMessage('done')}
      </div>
      <div className={`${styles.enhancedScoutingIsSelectingTitlesContainer} ${styles.flexGrow1}`}>
        <h3 className={`${styles.enhancedScoutingTitle} ${styles.enhancedScoutingTitleIsSelecting} ${styles.flexGrow1}`}>
          {title}
        </h3>
        {subtitle && <h4 className={`${styles.enhancedScoutingSubtitle} ${styles.enhancedScoutingSubtitleIsSelecting}`}>
          {subtitle}
        </h4>}
      </div>
      {onRight && <div
        className={`${styles.enhancedScoutingIsSelectingRightContainer} ${styles.cursorPointer}`} onClick={onRight}
      >
        {rightLabel ?? getMessage('next')}
        <Icon
          glyph={customRightIcon ?? Icon.set.ARROW_RIGHT}
          testId="enhanced-scouting-arrow-right"
          className={styles.enhancedScoutingIsSelectingDoneIconContainer}
        />
      </div>}
    </div>
  </div>
)
